import { Filesystem } from '@capacitor/filesystem';

export async function readFSFileAsBlob(
	path: string,
	format: string
): Promise<Blob> {
	await Filesystem.checkPermissions();

	const file = await Filesystem.readFile({ path });

	if (file.data instanceof Blob) {
		return file.data;
	}

	const byteCharacters = atob(file.data);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);

	return new Blob([byteArray], { type: `image/${format}` });
}
